/**
 * @generated SignedSource<<bdd6664062803833b25f873d22c5ff94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type EventDetailPairingsRound_round$data = {
  readonly courseLayout: {
    readonly holeCount: HoleCount;
  } | null | undefined;
  readonly player: {
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
  } | null | undefined;
  readonly transportationType: {
    readonly code: TransportationCode | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "EventDetailPairingsRound_round";
};
export type EventDetailPairingsRound_round$key = {
  readonly " $data"?: EventDetailPairingsRound_round$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailPairingsRound_round">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailPairingsRound_round",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "transportationType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseLayout",
      "kind": "LinkedField",
      "name": "courseLayout",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "holeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};

(node as any).hash = "a83263b325593e9ef11033b2433dfb27";

export default node;
